


























































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import {AloArbo, getDefaultAloArbo} from '@/models/alo/AloArbo'
import { AloPanier } from '@/models/alo/AloPanier'
import { ItemPanier } from '@/models/alo/ItemPanier'
import CartSupItem from '@/components/panier/CartSupItem.vue'

@Component({
  name: 'CartItem',
  props: {
    item:{
      type:Object,
      required:true
    },
    readOnly:{
      type:Boolean,
      default:false
    }
  },
  components:{CartSupItem}
})
export default class CartItem extends Vue {
  item!:ItemPanier   
  value!:string
  readOnly!:Boolean

  get hasOption() {
    return (this.item.prixSupplementsAccompagnement + this.item.prixSupplementsCarte) > 0
  }

  get showEdition(){
    return !this.readOnly &&  (this.item.plat.template == 'plat-produit-menu-breakfast' ||
           this.item.plat.template == 'plat-produit-accompagnement' ||
           this.item.plat.template == 'plat-produit-oeuf')
  }
  
  get commentaire() {
    return this.item.commentaire
  }

  set commentaire (value) { 
    this.$emit('updateItemCommentaire',value)    
  }

  get accompagnements(){
    let nbGratuitRestant = this.item.plat.qtyAccompagnementGratuit??0
    return this.item?.accompagnements.filter(i =>i.qty > 0).map(it => {      
      const item = {...it,prix: Math.max(0,it.qty - nbGratuitRestant) * this.item.plat.prixAccompagnement! }             
      nbGratuitRestant = Math.max(0,nbGratuitRestant-it.qty)
      return item
    })    
  }

  get libelle(){
    //@ts-ignore
    return Vue.$gt(this.item.plat).libelle
    //Commenté car Florent est en négo avec le client
    //@ts-ignore
    //return this.item.parentId?`${Vue.$gt(this.platsDic[this.item.parentId]).libelle} ${Vue.$gt(this.item.plat).libelle.toLowerCase()}` : Vue.$gt(this.item.plat).libelle
  }

  get qtyAccompagnements(){
    return this.accompagnements.reduce((total,a)=>{
      return total+a.qty
    },0)
  }

  udpateQty(qty:number){
    this.$emit('udpateQty',qty)    
  }  

  get platsDic(){    
    return this.$store.myGetters.platsDic
  }

  get defaultItems() {
    return this.plats.filter(p => p && p.template == "plat-produit-menu-breakfast-default-item")
  }

  get plats() {
    return (this.item.plat.platsIds?.map(id => this.platsDic[id]) || []).filter(it => it)
  }


}
